import { Component, EventEmitter, Input, Output, AfterViewInit, OnInit } from '@angular/core';
import { GiftCardsService } from 'src/app/services/gift-cards.service';
import { DateFormatterService } from 'src/app/services/date-formatter.service';

@Component({
  selector: 'app-gift-card',
  templateUrl: './gift-card.component.html',
  styleUrls: ['./gift-card.component.scss']
})
export class GiftCardComponent implements OnInit {

  @Input() card: any;
  tempCard: any;
  originalStatus!: boolean;
  currentCheckbox: any; // To store the reference of the current checkbox
  private confirmModalInstance: any;
  private deleteModalInstance: any;
  @Output() giftCardUpdated = new EventEmitter<void>();
  @Output() openEditForm = new EventEmitter<any>();
  @Output() newTab = new EventEmitter<boolean>();
  formatedDate!: string | null ;

  onEditGiftCard() {
    // Emit an event to tell the parent to open the form and pass the card data
    this.openEditForm.emit(this.card);
  }
  constructor(private giftCardsService: GiftCardsService, public formatDate: DateFormatterService) { 
  }

  ngOnInit(): void {
    this.formatedDate = this.formatDate.formatDate(this.card.expirationDate);
  }

  onCheckboxChange(event: any, card: any): void {
    this.tempCard = { ...card };
    this.originalStatus = card.active;
    this.currentCheckbox = event.target;
    this.openConfirmToggleModal(card.uid);
  }

  openConfirmToggleModal(cardId: string): void {
    const modalElement = document.getElementById('confirmStatusModal-' + cardId) as HTMLElement;
    if (modalElement) {
      this.confirmModalInstance = this.confirmModalInstance || new (window as any).bootstrap.Modal(modalElement);
      this.confirmModalInstance.show();
    }
  }


  confirmToggleActive(cardId: string): void {
    const newStatus = !this.tempCard.active;
    this.giftCardsService.updateGiftCardStatus(this.tempCard.uid, { active: newStatus })
      .then(() => {
        this.tempCard.active = newStatus;
        if (this.currentCheckbox) {
          this.currentCheckbox.checked = newStatus;
        }
        this.confirmModalInstance?.hide();
        this.newTab.emit(newStatus);
        this.giftCardUpdated.emit();
      //  handle any UI feedback here, like a success message.
      })
      .catch((error) => {
        console.error('Error updating voucher status:', error);
        this.currentCheckbox.checked = this.originalStatus;
      });
  }


  cancelToggle(): void {
    if (this.currentCheckbox) {
      this.currentCheckbox.checked = this.originalStatus;
    }
    this.confirmModalInstance?.hide();
    this.tempCard = null;
    this.currentCheckbox = null;
  }

  // Update delete modal logic as well
  openDeleteGiftCardModal(cardId: string): void {
    const modalElement = document.getElementById('deleteGiftCardModal-' + cardId) as HTMLElement;
    if (modalElement) {
      this.deleteModalInstance = this.deleteModalInstance || new (window as any).bootstrap.Modal(modalElement);
      this.deleteModalInstance.show();
    }
  }

  onDeleteGiftCard(cardId: string): void {
    this.giftCardsService.deleteGiftCard(cardId)
      .then(() => {
        this.deleteModalInstance?.hide();
        this.giftCardUpdated.emit();
      })
      .catch((error: any) => {
        console.error('Error deleting vouchers:', error);
      });
  }

}
